import { observable, runInAction } from "mobx"

import { Model } from "@/lib/Model.ts"

import type { IObservableValue } from "mobx"


export class GlobalLoaderModel extends Model {
  private showTimestamp: number | null = null
  private hideTimeoutId?: ReturnType<typeof setTimeout>

  readonly visible: IObservableValue<boolean>

  constructor() {
    super("GlobalLoaderModel")

    this.visible = observable.box(false)

    this.lifetime.add(() => {
      if (this.hideTimeoutId) {
        clearTimeout(this.hideTimeoutId)
      }
    }, "GlobalLoaderModel:clearTimeout")
  }

  readonly setLoading = (isLoading: boolean) => {
    if (isLoading) {
      runInAction(() => {
        this.visible.set(true)
      })
      this.showTimestamp = Date.now()

      if (this.hideTimeoutId) {
        clearTimeout(this.hideTimeoutId)
        this.hideTimeoutId = undefined
      }
    } else {
      const elapsed = Date.now() - (this.showTimestamp ?? 0)
      const minVisibleDuration = 300
      const remainingTime = Math.max(minVisibleDuration - elapsed, 0)

      this.hideTimeoutId = setTimeout(() => {
        runInAction(() => {
          this.visible.set(false)
        })
        this.hideTimeoutId = undefined
      }, remainingTime + minVisibleDuration)
    }
  }
}